<template>
    <div class="main">
        <BasicDialog @close="closeClicked" @back="backClicked" enableBack>
            <v-row no-gutters class="flex-column mx-sm-16 px-sm-16">



                <v-row no-gutters class="justify-center">
                    <v-col cols="12" style="position: relative;" class="d-flex justify-center">
                        <img style="position: absolute; top: 0px; left: 72px;"
                            :src="AppConfigs.staticImages.VERIFYOTP_MESSAGEBOX">
                        <img style="position: absolute; top: 25px; left: 80px;"
                            :src="AppConfigs.staticImages.VERIFYOTP_STARS">
                        <img style="position: absolute; top: 60px; left: 120px;"
                            :src="AppConfigs.staticImages.VERIFYOTP_TOOLTIP">
                        <img :src="AppConfigs.staticImages.VERIFYOTP">
                    </v-col>
                </v-row>




                <v-row no-gutters class="d-flex justify-center mt-4 flex-column align-center">
                    <span class="text-h5 font-weight-bold">OTP Verification</span>
                    <span class="text-body-2 mt-1 text-center">
                        Code is sent to
                        <span class="font-weight-bold">{{ phoneNumberInput.phone_number }}</span>
                        -
                        <button class="button--link" @click="backClicked">
                            Incorrect Number?
                        </button>
                    </span>
                </v-row>




                <v-row no-gutters class="mt-10">
                    <v-col cols="12">
                        <span style="opacity: .8; font-size: 15px;">OTP Code</span>
                        <v-text-field placeholder="x x x x x x" class="mt-1 pa-0" variant="solo" v-model="otp"
                            type="text" hide-details></v-text-field>
                        <div class="d-flex justify-center">
                            <span class="text-caption" style="color: grey; font-size: 12px">



                                Didn't receive code?



                                <button class="button--link px-2" @click="resendOTPClicked" :disabled="resendDisabled">
                                    Resend Code
                                    <span v-if="countdown > 0">
                                        {{ countdown }}
                                    </span>
                                </button>



                            </span>
                        </div>
                    </v-col>
                </v-row>





                <v-row no-gutters class="justify-center mt-5">
                    <v-btn class="rounded-pill button--primary text-body-2 font-weight-bold pa-6 px-7 d-flex"
                        @click="verifyOTP" :disabled="otpVerificationInProcess">
                        Verify Now
                    </v-btn>
                </v-row>
            </v-row>
        </BasicDialog>
    </div>
</template>



<script setup lang="ts">
import { AppConfigs } from "@/app.configs";
import { useSnackbar } from '@/composables/useSnackbar';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';
import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import type { VerifyPhoneNumberInput } from '@/interfaces/InHouseTasks/VerifyPhoneNumberInput';

const props = defineProps<{
	phoneNumberInput: VerifyPhoneNumberInput
}>();

const emit = defineEmits<{
	(e: 'back'): void
	(e: 'otpEntered'): void
}>();

const otp = ref('');
const countdown = ref(60);
const { showSnackbar } = useSnackbar();
const resendDisabled = ref(true);
const inHouseTasksStore = UserActivityStore();
const otpVerificationInProcess = ref(false);
let interval: NodeJS.Timeout | undefined;

const clearCountdown = () => {
	if (interval) {
		clearInterval(interval);
		interval = undefined;
	}
};

const startCountdown = () => {
	clearCountdown();
	resendDisabled.value = true;
	countdown.value = 60;
	interval = setInterval(() => {
		countdown.value -= 1;
		if (countdown.value === 0) {
			clearCountdown();
			resendDisabled.value = false;
		}
	}, 1000);
};

onMounted(() => {
	startCountdown();
});

onBeforeUnmount(() => {
	clearCountdown();
});

const verifyOTP = async () => {
	otpVerificationInProcess.value = true;
	try {
		await inHouseTasksStore.verifyOTP({ sms_code: otp.value });
		showSnackbar({
			message: 'OTP Verified successfully',
			color: 'info'
		});
		emit("otpEntered");
	} catch (error: any) {
		showSnackbar({
			message: error.message || 'There was an error.',
			color: 'error'
		});
	} finally {
		otpVerificationInProcess.value = false;
	}
};

const resendOTPClicked = async () => {
	startCountdown();
	showSnackbar({
		message: 'We are re-sending you an OTP.',
		color: 'info'
	});
	try {
		let sent = await inHouseTasksStore.resendOTP();
		if(sent) 
			showSnackbar({
				message: 'OTP Sent successfully',
				color: 'success'
			});
		else
			showSnackbar({
				message: 'Try sending OTP after some time.',
				color: 'error'
			});
	} catch (error) {
		showSnackbar({
			message: 'There was an error.',
			color: 'error'
		});
	}
};

const backClicked = () => {
	emit("back");
};
</script>